import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  updatePhNumOldNum: string;
  updatePhNumTranId: string;
}

const initialState: CommonState = {
  updatePhNumOldNum: '',
  updatePhNumTranId: '',
};

const pubSlice = createSlice({
  name: 'pubSlice',
  initialState,
  reducers: {
    setUpdatePhNumOldNum: (state, action: PayloadAction<string>) => {
      state.updatePhNumOldNum = action.payload;
    },
    setUpdatePhNumTranId: (state, action: PayloadAction<string>) => {
      state.updatePhNumTranId = action.payload;
    },
  },
});

const { setUpdatePhNumOldNum, setUpdatePhNumTranId } = pubSlice.actions;

export { setUpdatePhNumOldNum, setUpdatePhNumTranId };

export default pubSlice.reducer;
